export const InputTypes = {
  Decimal: "decimal",
  Date: "date",
  Text: "text"
}
